// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "content/" + "main" + "." + "265c02b5e370f3ff7c70" + ".css";
};